export const SUPPLIER_CERTIFICATES = [
  "ICTI",
  "BSCI",
  "SEDEX",
  "SMETA",
  "BETTER WORK",
  "FCCA",
  "FSC",
  "ISO14001",
  "SA8000",
  "ISO9001",
  "Global Recycled Standard 4.0 (GRS4.0)",
  "Global Security Verification (GSV)",
  "GMI",
  "消防",
  "环评",
];
